/**
 * Brand-tinted info chrome for guest booking + admin BookingPreview (matches apps/booking `bookingBrandInfoChromeStyles`).
 */
import { teboxDesignSystem as ds } from './tebox-design-system';

export const bookingBrandInfoTintMixDefaultPercent = 3.5;

export const bookingBrandInfoChromeBorderMixPercent = 12;

export function bookingBrandInfoTintCss(
  primaryOrAccentHex: string | undefined,
  mixPercent = bookingBrandInfoTintMixDefaultPercent,
): string {
  const pct = Math.min(100, Math.max(0, mixPercent));
  const base =
    (typeof primaryOrAccentHex === 'string' ? primaryOrAccentHex.trim() : '') ||
    ds.colors.accent.primary;
  return `color-mix(in srgb, ${base} ${pct}%, #ffffff)`;
}

export function bookingBrandInfoChromeStyles(brand: {
  primaryColor?: string;
  buttonColor?: string;
  tintMixPercent?: number;
  borderMixPercent?: number;
}): { backgroundColor: string; border: string } {
  const base =
    brand.primaryColor?.trim() ||
    brand.buttonColor?.trim() ||
    ds.colors.accent.primary;
  const tintPct = brand.tintMixPercent ?? bookingBrandInfoTintMixDefaultPercent;
  const borderPct = brand.borderMixPercent ?? bookingBrandInfoChromeBorderMixPercent;
  return {
    backgroundColor: bookingBrandInfoTintCss(base, tintPct),
    border: `1px solid color-mix(in srgb, ${base} ${borderPct}%, ${ds.colors.border.light})`,
  };
}
